import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface RolData {
  name: string;
}

export interface RolesResponse {
  success: boolean;
  message: string;
  data: RolData[];
}

interface RolesState {
  roles: RolData[];
  message: string;
  success: boolean;
}

const initialState: RolesState = {
  roles: [],
  message: "",
  success: false
};

const rolSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    loadRoles(state, action: PayloadAction<RolesResponse>) {
      state.roles = action.payload.data;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    diMissRoles(state) {
      state.roles = [];
      state.message = "";
      state.success = false;
    },
  },
});

export const { loadRoles, diMissRoles } = rolSlice.actions;

export default rolSlice.reducer;